import { useCallback, useEffect, useState } from "react";
import { useLocale, useService } from "../../../../hooks";

export const useFranchiseWithUs = () => {
  const { t } = useLocale();
  const { save } = useService("Data", "franchiseRequest");
  const { setTitle, setDescription, setKeywords } = useService("Meta");
  const { generateUID, getFranchiseRequest, showAlert } = useService("Misc");
  const [name, setname] = useState<string>("");
  const [email, setemail] = useState<string>("");
  const [mobile, setmobile] = useState<string>("");
  const [message, setmessage] = useState<string>("");
  const [pinCode, setpinCode] = useState<string>("");
  const [city, setcity] = useState<string>("");

  useEffect(() => {
    setTitle(
      "Become a Carmitra Partner | Start Car Service Franchise",
      "empty"
    );
    setDescription(
      "Become a partner with Carmitra! Start your own car service franchise with low investment and high returns. Join India’s trusted auto care brand today!"
    );
    setKeywords(
      "car service franchise, auto franchise India, Carmitra franchise, start franchise business, vehicle service franchise, automotive franchise, franchise opportunity, low investment franchise, car repair business"
    );
  }, []);

  const scrollToApplyForFranchise = useCallback(() => {
    document.getElementById("apply-for-franchise").scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  const sendFranchiseRequest = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      franchiseObject = {
        name,
        pinCode,
        email,
        mobile,
        message,
        city,
        uid: generateUID(),
        status: "raised",
      };
    if (name === "") {
      errorMsg = t("errorMsg.required.name");
      error = true;
    }
    if (email === "") {
      errorMsg = t("errorMsg.required.email");
      error = true;
    }
    if (mobile === "") {
      errorMsg = t("errorMsg.required.mobile");
      error = true;
    }
    if (pinCode === "") {
      errorMsg = t("errorMsg.required.pinCode");
      error = true;
    }
    if (city === "") {
      errorMsg = t("errorMsg.required.city");
      error = true;
    }
    if (message.length < 20) {
      errorMsg = t("errorMsg.validate.franchiseRequest");
      error = true;
    }
    if (!error) {
      await save(franchiseObject);
      const result = await getFranchiseRequest(franchiseObject);
      if (result.status) {
        showAlert({
          type: "info",
          msg: "Your franchise request has been submitted. We'll connect you back in 24 hours.",
        });
        setname("");
        setemail("");
        setmessage("");
        setmobile("");
        setcity("");
        setpinCode("");
      } else
        showAlert({ type: "error", msg: "Unable to send franchise request." });
    } else showAlert({ type: "error", msg: errorMsg });
  };
  return {
    sendFranchiseRequest,
    name,
    setname,
    email,
    setemail,
    mobile,
    setmobile,
    city,
    setcity,
    pinCode,
    setpinCode,
    message,
    setmessage,
    scrollToApplyForFranchise,
  };
};
